import { request } from './client.js';
import type { AssetContext, AssetListParams, AssetPage } from './types.js';

/** Every asset the Client's detections have named, with its group memberships (Story 15). */
export function listAssets(
  clientTenantId: string,
  params: AssetListParams,
  idToken: string,
): Promise<AssetPage> {
  return request<AssetPage>(
    'GET',
    `/tenants/${encodeURIComponent(clientTenantId)}/assets`,
    idToken,
    { query: { ...params } },
  );
}

/**
 * NinjaOne and ConnectSecure context for one asset, by name (task 164).
 * `asset` is a detection's `asset_name` or an alert's asset name.
 */
export function getAssetContext(
  clientTenantId: string,
  asset: string,
  idToken: string,
): Promise<AssetContext> {
  return request<AssetContext>(
    'GET',
    `/tenants/${encodeURIComponent(clientTenantId)}/assets/${encodeURIComponent(asset)}/context`,
    idToken,
  );
}
